export default __webpack_public_path__ + "static/service_request.6cad49c3afe8fb39501d89ade26f4507.png";